import { all, takeLatest } from 'redux-saga/effects';
import { LOGOUT } from '../redux/types/init';
import { logout } from './logout';
import { AUTHENTICATE_USER } from '../redux/types/authenticate';
import { authenticateUser } from './authenticate';
import { createETFToken, CreateTransactionID, GetTickerCode } from './etfTransaction';
import { ETFTOKEN, ETFTRANSACTIONID, GETTICKERCODE } from '../redux/types/etfTransaction';
import { orderBook } from './orderbook';
import { ORDER_HISTORY } from '../redux/types/orderbook';


function* rootSaga() {
  yield all([

    takeLatest(LOGOUT, logout),
    takeLatest(AUTHENTICATE_USER, authenticateUser),
    takeLatest(ETFTOKEN, createETFToken),
    takeLatest(ETFTRANSACTIONID, CreateTransactionID),
    takeLatest(ORDER_HISTORY, orderBook),
    takeLatest(GETTICKERCODE, GetTickerCode),

  ]);
}

export default rootSaga;